import { apiInstance } from "api/config/axios";
import { IApiResponse } from "api/models/IApiResponse";
import { getApiResponseData } from "api/services/api-service";
import { ICreateGameLessonRequest } from "api/models/request/ICreateGameLessonRequest";
import { ICreateGameLessonVersionRequest } from "api/models/request/ICreateGameLessonVersionRequest";
import { FileFlat } from "models/FileFlat";

const gameLessonApiBaseUrl = '/GameLesson';

export const createGameLesson = (
    request: ICreateGameLessonRequest & { workspaceId: string }
): Promise<IApiResponse<string>> => {
    return apiInstance
        .post(
            `${gameLessonApiBaseUrl}/workspaces/${request.workspaceId}/create`,
            request
        )
        .then((response) => getApiResponseData(response));
};

export const getGameFiles = (
    request: { workspaceId: string }
): Promise<IApiResponse<FileFlat[]>> => {
    return apiInstance
        .get(`${gameLessonApiBaseUrl}/workspaces/${request.workspaceId}/game-files`)
        .then((response) => getApiResponseData(response));
};

export const createGameLessonVersion = (
    request: ICreateGameLessonVersionRequest & { workspaceId: string }
): Promise<IApiResponse<string>> => {
    return apiInstance
        .post(
            `${gameLessonApiBaseUrl}/${request.lessonId}/workspaces/${request.workspaceId}/versions`,
            request
        )
        .then((response) => getApiResponseData(response));
};
